import ProviderAPI from "../redux/ProviderAPI";

export const getYacht = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "yacht/detailYacht",
    data,
    token,
  });
  
  return result;
};
